// GENERATED by scripts/stamp-build.js at build time (npm `prebuild`). Do not edit.
//
// The value committed to the repo is a PLACEHOLDER and says so in `source`. Every build
// overwrites this file, so a bundle whose source is `placeholder` was never stamped and a
// bundle whose source is `unresolved` was stamped where no commit could be determined.
export const buildInfo = {
  "sha": "1b2dc4a5716de6dbcdc237fb6ab1fd02b7cd4ef5",
  "source": "cloudflare-pages",
  "builtAt": "2026-11-04T11:28:37.281Z"
};

export default buildInfo;
